import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune_kpi_encyclopedia.jpg'

const paperInfo = {
    paperName: 'カスタマーサクセスKPI大全 -主要9種を大網羅-',
    thumbnail,
    feature1: 'KPIの最適な運用方法',
    feature2: 'どのKPIが自社に最適なのか',
    feature3: '一般的にどの指標が使用されているのか',
    description:
        'カスタマーサクセスは進捗状況を段階的に可視化できるよう、適切なKPIを設定することが必要不可欠になります。しかし、自社に最適なKPIを判断することは難しく、本格的な運用に悩んでいる企業も多いのではないでしょうか。本資料ではカスタマーサクセスで使用される主要なKPI9種を取り上げて、徹底解説しています。',
    formSrc: 'https://go.commmune.jp/l/915341/2022-06-07/h9rgr',
    type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
    return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
